import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import { store } from './vuex'

Vue.config.productionTip =  process.env.NODE_ENV === 'production' ? true : false
//Vue.prototype.$url = process.env.NODE_ENV === 'production' ? 'https://vrglass.com/agrinho/multiplayer/' : './'
//Vue.prototype.$url = process.env.NODE_ENV === 'production' ? 'https://localhost/agrinhos_front/dist/' : './'
//Vue.prototype.$url = process.env.NODE_ENV === 'production' ? 'https://agrinho.vrglass.com/vrglass/' : './'


Vue.prototype.$url = process.env.NODE_ENV === 'production' ? 'https://agrinhogame.sistemafaep.org.br/' : './'

Vue.prototype.$b = 'https://agrinho.vrglass.com/'
//Vue.prototype.$b = 'https://local.agrinhos.com.br/'
//Vue.prototype.$b = 'https://agrinhogame.sistemafaep.org.br'

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
